module.exports = __webpack_public_path__ + "img/avatar-pt-120.7f50f57b.png";